import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './hooks/useScrollToTop';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { BrochureProvider } from './components/BrochureProvider';
import { Home } from './pages/Home';
import { Tarieven } from './pages/Tarieven';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { ExterneVertrouwenspersoon } from './pages/ExterneVertrouwenspersoon';
import { HetPuntUitSpel } from './pages/HetPuntUitSpel';
import { VoorMensen } from './pages/VoorMensen';
import { OverOns } from './pages/OverOns';
import { InterneVsExterneVP } from './pages/InterneVsExterneVP';
import { PreventieOngewenstGedrag } from './pages/PreventieOngewenstGedrag';
import { Article } from './pages/Article';
import { AlgemeneVoorwaarden } from './pages/AlgemeneVoorwaarden';
import { Privacyverklaring } from './pages/Privacyverklaring';
import { NotFound } from './pages/NotFound';


function PraatUitRedirect() {
  useEffect(() => {
    window.location.replace('https://praatuit.nl/');
  }, []);

  return (
    <div className="container py-32 text-center">
      <h1 className="text-gray-600">Je wordt doorgestuurd naar PraatUit.nl...</h1>
    </div>
  );
}

// Router-less app shell so it can be wrapped in BrowserRouter (client)
// or StaticRouter (server prerender).
export function AppShell() {
  return (
    <BrochureProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/externe-vertrouwenspersoon" element={<ExterneVertrouwenspersoon />} />
            <Route path="/het-puntuit-spel" element={<HetPuntUitSpel />} />
            <Route path="/voor-mensen" element={<VoorMensen />} />
            <Route path="/voor-medewerkers" element={<PraatUitRedirect />} />
            <Route path="/over-ons" element={<OverOns />} />
            <Route path="/interne-vs-externe-vp" element={<InterneVsExterneVP />} />
            <Route path="/preventie-ongewenst-gedrag" element={<PreventieOngewenstGedrag />} />
            <Route path="/tarieven" element={<Tarieven />} />
            <Route path="/kennisbank" element={<Blog />} />
            <Route path="/kennisbank/:slug" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
            <Route path="/privacyverklaring" element={<Privacyverklaring />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>

      <CookieBanner />
    </BrochureProvider>
  );
}
